var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-0"},[_c('v-row',{staticClass:"text-center"},[_c('v-col',{staticClass:"px-0 text-left",attrs:{"cols":"12"}},[(!_vm.pond)?_c('Pond'):_vm._e(),(_vm.pond)?_c('Samples'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }